import cryptoRandomString from 'crypto-random-string';

/**
 * This function return a random string which is used for empty block titles
 * @param {number} length - The length for the random generated string.
 */
export const generateRandomString = (length) => cryptoRandomString({ length: length || 10, type: 'base64' });

/**
 * This function generates a random 24 long string for block ID. We need unique block IDs for each blocks
 */
export const generateBlockID = () => cryptoRandomString({ length: 24 });
/**
 * This function generates a random 32 long string for column ID. We need unique column IDs for each columns in each block
 */
export const generateColumnID = () => cryptoRandomString({ length: 32 });
/**
 * This function generates a random 36 long string for element ID. We need unique element IDs for each elements added to canvas
 */
export const generateElementID = () => cryptoRandomString({ length: 36 });
